import { render, staticRenderFns } from "./AllProductsArtworkVersionsModal.vue?vue&type=template&id=6b5f019c&scoped=true&"
import script from "./AllProductsArtworkVersionsModal.vue?vue&type=script&lang=js&"
export * from "./AllProductsArtworkVersionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f019c",
  null
  
)

export default component.exports